var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"styleNumberClass"},[_c('span',{staticClass:"copyStyle"},[_vm._v(_vm._s(_vm.styleNumber)),_c('span',{staticClass:"copyStyleNumber",on:{"click":_vm.seccendCopy}},[_vm._v("复制款号")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }